(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-icons-strap"]) return;
  try {
    

           
            
  $(document).ready(function() { 
    	findSelectedVariant();
  }); 
  $( ".ProductForm__Option" ).on('change', function() {
     var checked = $('body .HorizontalList__Item input:checked').val();
     console.log(checked);	
    
  });
  
  function findSelectedVariant(){
  	var checked = $('.ProductForm__Option option:selected').val();
    console.log(checked);
         var checked2 = $('body .HorizontalList__Item input:checked').val();
     console.log(checked2);	
    var checked_strap = $("#feature-strap").find("[data-vid='" + checked + "']"); 
    checked_strap.show();
  }
  
  function setSelectedVariant(e){ 
    var checked_strap = $("#feature-strap").find("[data-vid='" + e + "']"); 
  }
            
            

  } catch(e) { console.error(e); }
})();

})();
